'use strict';

var base = require('./base');

const baseDetails = require('base/product/detail');
const actions = require('./addedProductSuccessToaster');
const wishlist = require('./wishlist');
const photoswipe = require('../libs/photoswipe');
const utils = require('../libs/utils');

var isFirstSizeSelection = false;

/**
 * Updates the product name within the specified product container.
 * @param {string} name - The new name of the product.
 * @param {jQuery} $productContainer - The jQuery object representing the product container.
 */
function updateProductName(name, $productContainer) {
    const $productNames = $productContainer.find('.product-name');

    $productNames.filter(':not(.product-title)').html(name);

    $productNames.filter('.product-title').find('.product').text(name);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} product - product
 */
function createCarousel(imgs, $productContainer, product) {
    const $carousel = $productContainer.find('.pdp-image-carousel');
    const $navDots = $productContainer.find('.shots-navigation');
    const slickInitialized = $carousel.hasClass('slick-initialized');
    if (slickInitialized) {
        $carousel.slick('unslick');
        $carousel.empty();
    } else {
        $('> :not(.js-to-exclude-from-carousel)', $carousel).remove();
    }
    $navDots.empty();

    if (imgs && imgs.length) {
        for (var i = 0; i < imgs.length; i++) {
            $carousel.append(`<a href="${imgs[i].url}" class="pdp-image-item pswp-wide-img ${i === 0 || i % 2 !== 0 ? 'pdp-image-row' : ''}">
                <img src="${imgs[i].url}" class="d-block img-fluid" alt="${product.productName} + ' - ' +  ${Number(imgs[i].index + 1)}" itemprop="image">
            </a>`);
            if ($navDots.length && imgs.length > 1 && (i === 0 || i % 2 !== 0)) {
                if ($carousel.hasClass('pdp-dun-image-carousel')) {
                    const $resource = $carousel.data('shots-resource');
                    $navDots.append(
                        `<li tabindex="0" class="shots-navigation-element ${i === 0 ? 'shots-navigation-element-active' : ''}">${i + 1 + ' ' + $resource + ' ' + imgs.length}</li>`
                    );
                } else {
                    $navDots.append(`<li tabindex="0" class="shots-navigation-element ${i === 0 ? 'shots-navigation-element-active' : ''}"></li>`);
                }
            }
        }
        photoswipe.initZoomGallery();
    }

    if (!slickInitialized) {
        $('.js-to-exclude-from-carousel', $carousel).appendTo($carousel);
    }
    $(document).trigger('pdpSlickInit');
}

/**
 * Update url with if its a first size selection
 * @param {string} selectedUrl - Selected attribute URL
 * @return {string} updated is returned
 */
function getSelectionUrl(selectedUrl) {
    if ($('.attributes [data-attr*=color]').length) {
        isFirstSizeSelection = true;
    }
    let url = new URL(selectedUrl);
    if (!isFirstSizeSelection) {
        url.searchParams.append('firstSelection', 'true');
    }
    if ($('.variations-overlay-content').is(':visible')) {
        url.searchParams.append('isOverlay', 'true');
    }
    if ($('.product-quickview').is(':visible')) {
        url.searchParams.append('enableQuickView', 'true');
    }
    url.searchParams.append('isPDP', 'true');
    isFirstSizeSelection = true;
    return url.toString();
}

/**
 * Updates the wishlist Data in the PDP page
 * @param {Object} data - The response Object.
 */
function updateWishlistData(data) {
    const productId = data.product.id;
    const url = $('.remove-from-wishlist-url').val();
    const wishlistProductIdTag = $('#wishlist-product-ID');
    const WISHLIST_KEY = 'user_wishlist_product_ids';
    const storedPIDs = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    wishlistProductIdTag.val(productId);
    const $form = wishlistProductIdTag.closest('form');
    if ($form.length) {
        const isInWishlist = storedPIDs.includes(productId);
        if (isInWishlist) {
            $form.find('.wishlist-wrapper').addClass('added-to-wishlist');
            $form.attr('action', $form.attr('action').replace('Wishlist-AddProduct', 'Wishlist-RemoveProduct'));
            $('.js-delete-from-wishlist').data('href', url + '?pid=' + productId);
        } else {
            $form.find('.wishlist-wrapper').removeClass('added-to-wishlist');
            $form.attr('action', $form.attr('action').replace('Wishlist-RemoveProduct', 'Wishlist-AddProduct'));
        }
    }
}

/**
 * Updates the canonicalUrl link Data in the PDP page
 * @param {Object} data - The response Object.
 */
function updateCanonicalURL(data) {
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    canonicalLink.href = data.canonicalUrl;
}

/**
 * For the Product, check and remove Accordion Detail Groups which are emtpy/ do not have any details.
 */
baseDetails.removeEmptyDetailGroups = function () {
    var $attrGroups = $('.pdp-attr-group-wrapper .pdp-attr-group');
    $attrGroups.each(function () {
        var $group = $(this);
        if ($group.find('.accordion-body').html()?.trim()) {
            $group.removeClass('d-none');
        } else {
            $group.addClass('d-none');
        }
    });
};

baseDetails.updateAttributesAndDetails = function () {
    $('body').on('product:statusUpdate', function (e, data) {
        var $productContainer = $('.product-detail');
        const shortDescription = data.shortDescription;
        const charLimit = parseInt($('.char-limit-count').val(), 10);
        const $shortDescriptionEle = $productContainer.find('.short-description');
        const showViewButton = shortDescription && charLimit > shortDescription.length;
        $productContainer.find('.long-description-wrapper .content, .long-description .content').html(data.longDescription);
        $shortDescriptionEle.find('.content').toggleClass('truncate-text', !!charLimit);
        $shortDescriptionEle.find('.view-more-btn').toggleClass('d-none', showViewButton);
        $shortDescriptionEle.find('.full-text').val(shortDescription);
        $shortDescriptionEle.find('.content .text').html(shortDescription);
        baseDetails.limitText();
        $productContainer.find('.description-and-detail .product-attributes').empty().html(data.attributesHtml);
    });
};

baseDetails.updateProductData = function () {
    const $body = $('body');
    $body.on('product:afterAttributeSelect', function (e, response) {
        const $productContainer = response.container;
        const data = response.data;
        // Check if size_drop_down event has already been pushed
        const alreadyPushed = window.dataLayer ? window.dataLayer.some((item) => item.event === 'size_drop_down') : [];
        if ('datalayer' in data && data.datalayer[0].event === 'size_drop_down' && !alreadyPushed) {
            window.dataLayer?.push(data.datalayer[0]);
        }

        const product = data.product;
        updateProductName(product.productName, $productContainer);

        // update personalization button when variant is changed
        if ((product.hasEmbossing || product.hasEngraving) && product.available) {
            $('.js-personalization-btn-wrapper').removeClass('d-none');
        } else {
            $('.js-personalization-btn-wrapper').addClass('d-none');
        }

        // update notifyMe button when variant is changed
        if (product.notifyMe) {
            $('.notify-me-link').removeClass('d-none');
        } else {
            $('.notify-me-link').addClass('d-none');
        }

        // push view_item event when variant is changed
        const isViewItemAlreadyPushed = window.dataLayer
            ? window.dataLayer.some((item) => typeof item === 'object' && item['gtm.uniqueEventId'] === data.datalayerItems.uniqueEventId)
            : false;
        if ('datalayer' in data && !isViewItemAlreadyPushed) {
            const dataLayerItems = data.datalayerItems;
            let viewItemEventData = {
                category: 'Product',
                event: 'view_item',
                name: 'Product Detail View',
                reference: 'rKPI_P1',
                'gtm.uniqueEventId': dataLayerItems.uniqueEventId,
            };
            let ecommerceObj = {
                currency: dataLayerItems.currency,
                items: [],
            };
            ecommerceObj.items.push(dataLayerItems);
            viewItemEventData.ecommerce = ecommerceObj;
            if (window.dataLayer) {
                window.dataLayer.push(viewItemEventData);
            }
        }

        if (!$body.hasClass('pdp-partial-loading')) {
            // Update primary images
            var primaryImageUrls = product.images.large;

            if ($productContainer.attr('data-product-container') !== undefined) {
                primaryImageUrls = product.images.large.filter((image) => image.alt === 'DAM_BGRD_0002');
            }

            if (primaryImageUrls) {
                createCarousel(primaryImageUrls, $productContainer, product);
            }
        }

        window.selectionLoading = true;
        var selectedColor = '';
        product.variationAttributes.forEach(function (attr) {
            var $attr = '[data-attr="' + attr.id + '"]';
            var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
            $defaultOption.attr('value', '');
            var selectedval = '';
            var infoMsg = '';
            attr.values.forEach(function (attrValue) {
                var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
                if (attrValue.selected) {
                    selectedval = attrValue.url;
                    infoMsg = attrValue.description;
                }
                if (!attrValue.selectable) {
                    $attrValue.attr('disabled', false);
                }
                $attrValue.toggleClass('hide', !attrValue.hasvariant);
                // Update stock message
                const $attrItem = $attrValue.closest('.attribute-item');
                $attrItem.find('.icon-wrapper').toggleClass('d-none', attrValue.selectable);
                $attrItem.find('.attribute-msg-text').text(attrValue.stockMsg || attrValue.preorderMsg);
            });
            let valueToUpdate = selectedval;
            const $selectElement = $productContainer.find(`${$attr} .select-${attr.id}`);
            if ($selectElement.first().find(`option[value="${selectedval}"]:not(.no-hide)`).hasClass('hide')) {
                valueToUpdate = '';
            }
            $selectElement.val(valueToUpdate).change();
            var $tooltop = $productContainer.find($attr + ' .icon-info');
            if (infoMsg) {
                $tooltop.addClass('active').find('.tooltip').text(infoMsg);
            } else {
                $tooltop.removeClass('active').find('.tooltip').text('');
            }
            const $attrBtn = $productContainer.find(`[data-attr="${attr.id}"] .attribute-btn`);
            if (selectedval && attr.displayValue) {
                $attrBtn.addClass('selected').find('.selected-value').text(attr.displayValue);
            } else {
                $attrBtn.removeClass('selected').find('.selected-value').text('');
            }
            $('.notify-error-text').removeClass('d-block');
            if (attr.id === 'color') {
                selectedColor = attr.displayValue;
            }
        });

        $productContainer.find('.attributes').addClass('active');
        if ($('.quickview-wrapper').length === 0) {
            const $addToCartSlider = $('.add-to-cart-slider', response.container);
            const $addTocart = $addToCartSlider.siblings('button.add-to-cart').first();

            if ('charmsHtml' in product) {
                const $charmsContainer = $('.js-charms-container', $productContainer);
                $charmsContainer.html(product.charmsHtml);
            }

            if ('attrGroupHtml' in product) {
                const $attrGroupContainer = $('.description-and-detail', $productContainer);
                $attrGroupContainer.html(product.attrGroupHtml);
                baseDetails.removeEmptyDetailGroups();

                let $productReminder = $('.product-reminder-module', $attrGroupContainer);
                let $sizeChartProductReminder = $('[data-attr="size"] .product-reminder-module');
                if ($productReminder.length > 0 && $sizeChartProductReminder.length > 0) {
                    $sizeChartProductReminder.html($productReminder.html());
                }
            }

            if ('pdpButtonHtml' in product) {
                $('.pdp-buttons-wrapper').html(product.pdpButtonHtml);
            }

            if (product.available && product.readyToOrder) {
                if ($addToCartSlider.hasClass('active')) {
                    $addToCartSlider.removeClass('active');
                    const $chamAttr = $('.attribute-charm').first();
                    if ($chamAttr.length === 0 || !$chamAttr.hasClass('attribute-charm-alphabet') || $chamAttr.hasClass('selected')) {
                        $addTocart.click();
                    }
                }
                $addTocart.data('readyToOrder', true);
                $('.add-to-wishlist-form.left-section-wishlist').removeClass('d-none').addClass('animation-active');
            }
            $(document).trigger('updateNextSlider');
            $('.slider-container.active .slider-close').click();
            if (product.available && product.readyToOrder) {
                $('.attribute-charm.attribute-charm-alphabet:not(.selected)').click();
            }
            $('body').trigger('product:afterAttributeHtmlUpdated');
        }
        $('.notify-me-link', response.container).data('queryString', data.queryString || '');
        window.selectionLoading = false;
        updateWishlistData(response.data);
        baseDetails.markWishlistIconsFromLocalStorage(response.data.product.id, 'pdp');
        $('.quickview-wrapper .product-quickview .add-to-wishlist-form, .add-to-wishlist-form').removeClass('not-ready-to-order');
        $('.quickview-wrapper .product-quickview .add-to-wishlist-form .icon-heart, .add-to-wishlist-form .icon-heart').attr('data-target', '#addToWishlistModal');
        // Update canonical URL and state only in PDP
        if (window.app.isPDP()) {
            updateCanonicalURL(response.data);
            window.history.pushState({}, document.title, response.data.canonicalUrl);
        }

        // Update Product details in PDP Accordion
        const $attrGroupProductID = $productContainer.find('.description-and-detail .pdp-attr-group-definition .pdp-attr_value.pdp-attr_product-id');
        if ($attrGroupProductID.length) {
            $attrGroupProductID.html(product.id);
        }
        const $attrGroupColor = $productContainer.find('.description-and-detail .pdp-attr-group-definition .pdp-attr_value.pdp-attr_color');
        if ($attrGroupColor.length) {
            if (selectedColor) {
                $attrGroupColor.removeClass('d-none').html(selectedColor);
            } else {
                $attrGroupColor.addClass('d-none').html('');
            }
        }
        $body.trigger('gtm:update:event', { response: data, target: $productContainer });
    });
};
baseDetails.reinitEvents = function () {
    window.selectionLoading = false;
    const $document = $(document);
    const $body = $('body');
    $document.off('click', '[data-attr="color"] button').on('click', '[data-attr="color"] button', function (e) {
        e.preventDefault();
        $(this).closest('.attribute').find('.error-msg').addClass('d-none');
        $(this).closest('.attribute').find('label').removeClass('d-none');
        if (window.selectionLoading) {
            return;
        }
        const $this = $(this);

        if ($this.find('.selected').length || $this.attr('disabled')) {
            return;
        }

        // Remove 'selected' class from prev selected swatch buttons
        $('[data-attr="color"] button .swatch-circle.selected').removeClass('selected');

        // Add 'selected' class to the clicked swatch
        $this.find('.swatch-circle').addClass('selected');

        var $productContainer = $this.closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $this.closest('.product-detail');
        }
        const url = $this.attr('data-url');
        if (url !== undefined) {
            base.attributeSelect(getSelectionUrl(url), $productContainer);
        }
    });

    $document.off('click', '[data-attr="size"] button').on('click', '[data-attr="size"] button', function (e) {
        e.preventDefault();
        $('.select-size-error-msg').addClass('d-none');
        let $thisAttr = $(this).closest('.attribute');
        $thisAttr.find('.error-msg').addClass('d-none');
        $thisAttr.find('label').removeClass('d-none');
        if (window.selectionLoading) {
            return;
        }
        let $this = $(this);
        if ($this.hasClass('notify-me-link')) {
            let $closestRadio = $this.closest('.attribute-item').find('[data-attr-value]');
            if ($closestRadio.length) {
                $this = $closestRadio;
            }
        }
        if ($this.find('.selected').length || $this.attr('disabled')) {
            return;
        }
        // Remove 'selected' class from prev selected swatch buttons
        $('[data-attr="size"] button .size-value.selected').removeClass('selected');
        // Add 'selected' class to the clicked swatch
        $this.find('.size-value').addClass('selected');
        var $productContainer = $this.closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $this.closest('.product-detail');
        }
        $this.data('url', $('[data-attr="size"] button .size-value.selected').attr('value'));
        const url = getSelectionUrl($this.data('url'));
        if (url) {
            $body.addClass('pdp-partial-loading');
        }
        base.attributeSelect(url, $productContainer);
    });
    $document.ajaxError(function () {
        $body.removeClass('pdp-partial-loading');
    });
    $('select[class*="select-"] option:selected').each(function () {
        const $this = $(this);
        const $thisWrapper = $this.closest('.select-attribute-wrapper');
        const description = $this.data('description');
        if (description) {
            $thisWrapper.find('.icon-info').addClass('active');
            $thisWrapper.find('.tooltip').text(description);
        }
    });

    $document.off('change', 'select[class*="select-"], .options-select').on('change', 'select[class*="select-"], .options-select', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $selectedEle = $this.next().find('.select2-selection__rendered');
        if ($('.variations-overlay-content').is(':visible')) {
            const selectedValue = $selectedEle.length > 0 ? $selectedEle.html().trim() : ''; // Get the selected value
            const syncId = $this.data('sync-id'); // Get the sync ID
            // Find the corresponding overlay dropdown and update its value
            $(`.variations-overlay-content .attributes .attribute .custom-select[data-sync-id="${syncId}"]`)
                .next()
                .find('.select2-selection__rendered')
                .html(selectedValue)
                .trigger('change');
            $this.closest('.attribute').find('label').removeClass('d-none');
            $this.closest('.attribute').find('.error-msg').addClass('d-none');
        }
        if (window.selectionLoading) {
            return;
        }

        var $productContainer = $this.closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $this.closest('.product-detail');
        }
        var selectedValueofDropdown = $this.next().find('.select2-selection__rendered');
        selectedValueofDropdown = selectedValueofDropdown.length > 0 && selectedValueofDropdown.html() ? selectedValueofDropdown.html().trim() : '';
        if (selectedValueofDropdown !== '') {
            $this.closest('.attribute').find('.error-msg').addClass('d-none');
            $this.closest('.attribute').find('label').removeClass('d-none');
        }

        const url = getSelectionUrl(e.currentTarget.value);
        base.attributeSelect(url, $productContainer);
    });

    $document.off('change', '.quantity-select').on('change', '.quantity-select', function (e) {
        e.preventDefault();
        if (window.selectionLoading) {
            return;
        }
        const $this = $(this);

        var $productContainer = $this.closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $this.closest('.modal-content').find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            const url = getSelectionUrl($(e.currentTarget).find('option:selected').data('url'));
            base.attributeSelect(url, $productContainer);
        }
    });
    $document.on('click', '.add-to-cart-slider', function (e) {
        e.preventDefault();
        $(this).addClass('active');
    });
    $document.on('updateNextSlider', function () {
        const $nextSelectorId = $('.attribute:not(.attribute-swatch) .selected-value:empty').first().closest('.attribute').children('.slider-container').attr('id') || '';
        if ($nextSelectorId) {
            $('.add-to-cart-slider').data('target-slider', '#' + $nextSelectorId);
        }
    });
    $document.trigger('updateNextSlider');
};

baseDetails.availability = base.availability;

baseDetails.addToCart = base.addToCart;

baseDetails.seeProductFullDetails = function () {
    $(document).on('click', '.see-full-details-btn', function (e) {
        e.preventDefault();
        const $target = $('.long-description');
        if ($target.length) {
            $('html, body').animate(
                {
                    scrollTop: $target.offset().top - 300,
                },
                1000
            );
        }
    });
};

baseDetails.imageSlick = function () {
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            setTimeout(function () {
                $(document).trigger('pdpSlickInit');
            }, 100);
        }
    });

    $(document).on('pdpSlickInit', function () {
        if (document.hidden) {
            return;
        }
        $('.pdp-image-carousel').each(function () {
            $(this).trigger('pdpSlickInit:before');
            var $this = $(this);
            var $thisparent = $this.parent();
            var widthThreshold = $this.data('width-threshold');

            // If there's a width threshold, apply Slick only if the window width is below it
            if (widthThreshold && $(window).width() >= widthThreshold) {
                return;
            }

            if ($this.hasClass('slick-initialized')) {
                return;
            }

            if (!$this.hasClass('slick-initialized')) {
                let $elementsToExclude = $this.find('.js-to-exclude-from-carousel');
                if ($elementsToExclude.length) {
                    $elementsToExclude.insertAfter($this);
                }
                // Common Slick settings
                var slickOptions = {
                    dots: true,
                    arrows: true,
                    infinite: true,
                    speed: 500,
                    touchThreshold: 100,
                    slidesToShow: $this.data('slides-to-show') || 1,
                    slidesToScroll: $this.data('slides-to-scroll') || 1,
                    appendDots: $thisparent.find('.pdp-image-progress'),
                    nextArrow: $thisparent.find('.slick-next'),
                    prevArrow: $thisparent.find('.slick-prev'),
                    responsive: $this.data('responsive') || [],
                };

                // Check if custom pagination is configured
                var $customPaginationSelector = $thisparent.find('.pdp-image-custom-pagination');
                if ($customPaginationSelector.length) {
                    // Update pagination on init
                    $this.on('init', function (event, slick) {
                        var currentSlide = slick.currentSlide + 1;
                        var totalSlides = slick.slideCount;
                        $customPaginationSelector.text(`${currentSlide} / ${totalSlides}`);
                    });

                    // Update pagination on afterChange
                    $this.on('afterChange', function (event, slick, currentSlide) {
                        var current = currentSlide + 1;
                        var total = slick.slideCount;
                        $customPaginationSelector.text(`${current} / ${total}`);
                    });
                } else {
                    var $parent = $this.closest('.primary-images');

                    $this.on('init', function (event, slick) {
                        $('.js-custom-pagination-total-slides', $parent).text('/' + slick.slideCount);
                    });
                }

                // Initialize Slick
                $this.slick(slickOptions);
            }
        });

        const $productVideo = $('.product-video');
        if ($productVideo.length) {
            const videojs = require('video.js').default;
            const $videoPlayInCarousel = $('.video-play-in-carousel');

            $('.pdp-image-carousel').on('afterChange', function () {
                const $activeVideoSlide = $('.slick-active .video-js');

                if ($activeVideoSlide.length) {
                    const player = videojs.getPlayer($(this).find('.slick-active .product-video').attr('id'));

                    $videoPlayInCarousel.addClass('d-none');
                    if (utils.detectIOS()) {
                        player.playsinline(true);
                    } else {
                        player.play();
                    }
                } else {
                    $videoPlayInCarousel.removeClass('d-none');
                }
            });

            $videoPlayInCarousel.on('click', function () {
                const $nextVideoProduct = $('.video-js').parents('.slick-slide:not(.slick-cloned)').last();
                const slickIndex = $nextVideoProduct.data('slick-index');
                $('.pdp-image-carousel').slick('slickGoTo', slickIndex);
            });

            $productVideo.each(function () {
                const $this = $(this);
                let settings = $this.attr('data-settings');
                try {
                    settings = JSON.parse(settings);
                } catch (e) {
                    settings = {};
                }

                settings.fill = true;
                const player = videojs($this[0], settings);
                const $activeVideo = $this.parents('.slick-active');
                const $videoElement = $('.pdp-video-item:last-child:nth-child(2n), .pdp-video-item:first-child');

                if ($activeVideo.length) {
                    setTimeout(() => {
                        player.play();
                    }, 500);
                    $videoPlayInCarousel.addClass('d-none');
                }
                if ($videoElement.length) {
                    $videoElement.find('.video-js').addClass('vjs-fluid');
                }
            });
        }
    });
    $(document).trigger('pdpSlickInit');
};

/**
 * Limit the number of characters to display
 */
baseDetails.limitText = function () {
    var $shortDescriptionTextContent = $('.short-description.content');
    if ($shortDescriptionTextContent.hasClass('truncate-text')) {
        var textValue = $('.full-text').val();
        textValue = textValue && textValue.trim();
        var charLimit = $('.char-limit-count').val();
        var integerValue = parseInt(charLimit, 10);

        if (textValue.length > integerValue) {
            textValue = textValue.substring(0, integerValue) + '...';
        }
        $shortDescriptionTextContent.find('.text').html(textValue);
    }
};
baseDetails.seeFullDescription = function () {
    $('body').on('click', '.view-more-btn', function (e) {
        var $shortDescriptionTextContent = $('.short-description.content');
        var textValue = $('.full-text').val();
        e.preventDefault();
        $shortDescriptionTextContent.removeClass('truncate-text');
        $shortDescriptionTextContent.find('.text').html(textValue);
        $shortDescriptionTextContent.find('.view-more-btn').addClass('d-none');
        $shortDescriptionTextContent.find('.view-less-btn').removeClass('d-none');
    });
};

baseDetails.seeLessDescription = function () {
    $('body').on('click', '.view-less-btn', function (e) {
        var $shortDescriptionTextContent = $('.short-description.content');
        e.preventDefault();
        $shortDescriptionTextContent.addClass('truncate-text');
        $shortDescriptionTextContent.find('.view-more-btn').removeClass('d-none');
        $shortDescriptionTextContent.find('.view-less-btn').addClass('d-none');
        baseDetails.limitText();
    });
};

baseDetails.checkProductFullDetailsTextHeight = function () {
    const element = $('.long-description-wrapper .content');
    const lineHeight = parseFloat(element.css('line-height')); // Get line height of the text
    const maxHeight = lineHeight * 2;

    if (element[0]) {
        if (element[0].scrollHeight > maxHeight && element[0].scrollHeight >= lineHeight) {
            element.addClass('box-shadow'); // Add shadow if content exceeds 2 or 1 lines
        }
    }
};

baseDetails.removeProductFromWishlist = function () {
    $('body').on('click', '.successful-add-to-wishlist-modal .close', function (e) {
        e.preventDefault();
        $('.successful-add-to-wishlist-modal').modal('hide');
    });
};

baseDetails.wishlistCancelBtnClick = function () {
    $('body').on('click', '.remove-from-wishlist-modal .cancel-btn', function () {
        $(this).closest('.product-wrapper').find('.wishlist-wrapper').addClass('added-to-wishlist');
        $('.remove-from-wishlist-modal').modal('hide');
    });

    $('body').on('click', '.remove-from-wishlist-modal .close', function (e) {
        e.preventDefault();
        $('.remove-from-wishlist-modal').modal('hide');
    });
};

baseDetails.sizeChart = function () {
    $('.size-chart a, .slider-opener[data-target-slider="#size-chart-size"]')
        .off('click')
        .on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            const url = $this.attr('href');
            var $prodSizeChart = $this.closest('.product-detail').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                        if (data.datalayer) {
                            $('body').trigger('gtm:add:event', data);
                        }
                    },
                });
            }
            $prodSizeChart.addClass('active');
        });

    var $sizeChart = $('.size-chart-collapsible');
    $('body').on('click touchstart', function (e) {
        if ($('.size-chart').has(e.target).length <= 0) {
            $sizeChart.removeClass('active');
        }
    });
};

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
baseDetails.methods.updateAddToCartEnableDisableOtherElements = function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
    $('button.js-open-personalization-modal').attr('disabled', enableOrDisable);
};

baseDetails.updateAddToCart = function () {
    $('body').on('product:updateAddToCart', function (e, response) {
        const notifyMe = response.product.notifyMe;
        const sellabilityRestrictedForCountry = response.product.restrictedForCurrentLocale;
        const readyToOrder = response.product.readyToOrder;
        const product = response.product;
        let disableAddToCart = notifyMe || sellabilityRestrictedForCountry;
        const $contaniner = response.$productContainer;
        let $addToCartSlider = $('.add-to-cart-slider, .floating-add-to-cart-btn, .js-keep-size-selector', $contaniner);

        if ($addToCartSlider.length && !$addToCartSlider.hasClass('js-keep-size-selector')) {
            $addToCartSlider.toggleClass('d-none', notifyMe || readyToOrder);
            if ($('.add-to-cart-slider , .floating-add-to-cart-btn').length) {
                disableAddToCart = disableAddToCart || !readyToOrder;
            }
        } else if ($addToCartSlider.length && $addToCartSlider.hasClass('js-keep-size-selector')) {
            let $checkedSize = $('#sliter-attribute-size input[name="attribute-radio-size"]:checked');
            if ($checkedSize.length) {
                $checkedSize.trigger('change').prop('checked', false);
            }
        }
        if ($('.charms-slider-opener', $contaniner).length) {
            const $charmAttrEle = $('.attribute-charm', $contaniner).first();
            const isCharmSelected = $charmAttrEle.hasClass('selected');
            if (!isCharmSelected) {
                disableAddToCart = true;
            }
            $('.charms-slider-opener', $contaniner).toggleClass('d-none', notifyMe || !readyToOrder);
            $charmAttrEle.toggleClass('d-none', notifyMe);
        }
        if (product.enableAddToCartOnVGChange && !notifyMe) {
            disableAddToCart = false;
        }
        $('button.add-to-cart, .floating-add-to-cart-btn', $contaniner).toggleClass('d-none', disableAddToCart).attr('data-pid', response.product.id);

        $('.js-personalization-btn-wrapper', $contaniner).toggleClass('d-none', disableAddToCart);
        $('.js-open-personalization-modal', $contaniner).attr('data-url', response.product.personalizationUrl);
        $('.pdp-right-wrapper', $contaniner).toggleClass('notifyme-active', notifyMe);
        const $serviceBlock = $('.product-service-block', $contaniner);
        $serviceBlock.removeClass('d-none').toggleClass('d-none', $serviceBlock.children(':visible').length === 0);
        var enable = $('.product-availability')
            .toArray()
            .every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
        baseDetails.methods.updateAddToCartEnableDisableOtherElements(!enable);
    });
    const $serviceBlock = $('.product-service-block');
    $serviceBlock.toggleClass('d-none', $serviceBlock.children(':visible').length === 0);
};

baseDetails.initSuccessToaster = actions.methods.initSuccessToaster;
baseDetails.initWishlistToaster = actions.methods.initWishlistToaster;

baseDetails.updateProductBadges = function () {
    const $body = $('body');
    $body.on('product:afterAttributeSelect', function (e, response) {
        const $productContainer = response.container;
        const data = response.data;
        const product = data.product;

        const $badgesWrapper = $productContainer.find('.badges-wrapper');
        if ($badgesWrapper.hasClass('dun-badges-wrapper')) {
            if (product.badgeTag) {
                $badgesWrapper.find('.badge').text(product.badgeTag);
            }
        } else {
            var allBadges = [];
            $badgesWrapper.empty();
            if (product.badgesToShow) {
                $badgesWrapper.attr('data-badges-all', product.badgesToShow.join());
                allBadges = product.badgesToShow;
            }
            allBadges.forEach(function (badgeText) {
                var badge = $('<span>', {
                    class: 'badge',
                    text: badgeText,
                });
                $badgesWrapper.append(badge);
            });
        }
        $body.removeClass('pdp-partial-loading');
    });
};

baseDetails.mountMeasMerizemodal = function () {
    $('body').on('click', '#measmerize-link', function () {
        if (window.measmerize && window.measmerize.modal && typeof window.measmerize.modal.mount === 'function') {
            window.measmerize.modal.mount();
        }
    });
};

baseDetails.hoverWishlistForm = wishlist.methods.hoverWishlistForm;
baseDetails.initAddWishlistForm = wishlist.methods.initAddWishlistForm;
baseDetails.initRemoveWishlistForm = wishlist.methods.initRemoveWishlistForm;
baseDetails.productTileRemoveWishlistForm = wishlist.methods.productTileRemoveWishlistForm;
baseDetails.markWishlistIconsFromLocalStorage = wishlist.methods.markWishlistIconsFromLocalStorage;
baseDetails.initPhotoswipe = function () {
    photoswipe.initZoomGallery();
};

module.exports = baseDetails;
